import styled from "styled-components";

interface isActive {
    active?: boolean;
}

export const HeaderComponent = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
`;

export const HeaderContent = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

export const LogoDiv = styled.div``;

export const Logo = styled.img`
    display: flex;
    align-items: center;

    width: auto;
    height: 50px;
    @media only screen and (max-width: 1000px) {
        width: auto;
        height: 30px;
    }
`;

export const NavMenu = styled.div`
    display: flex;
    text-align: center;
    align-items: center;
    font-size: 16px;
    font-family: "Poppins";
    margin: 0% 2%;
    color:  var(--purple-bhbusmidia);
    font-weight: 600;
`;

export const NavItem = styled.span<isActive>`
    cursor: pointer;
    padding: 0 5px;
    text-decoration: ${(props) => (props.active ? 'overline' : 'none')};
    text-decoration-thickness: 4px;
    text-underline-offset: 3px;
    /* text-decoration-color: #95246D; */
    color: ${(props) => (props.active ? 'var(--orange)' : 'inherit')};

    &:hover {
        text-decoration: overline;
        text-decoration-thickness: 4px;
        /* text-decoration-color: #95246D; */
        text-underline-offset: 3px;
        color: var(--orange);
    }
`;

export const SearchDiv = styled.div``;

export const MobileDiv = styled.div`
    margin: 0px 5px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100px;
`;

export const IconsDiv = styled.div`
    padding: 1px;
`;
